import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";
import { KONTAKT } from "../config/kontakt";

const KEY = "kontakt_info";
const DEF = {
  adr1: "Milchbauernhof Gehrke",
  adr2: "Ostlandweg 1",
  adr3: "38464 Groß Sisbeck",
  oz1: "Mo – Fr: 07:00 – 18:00 Uhr",
  oz2: "Sa: 07:00 – 14:00 Uhr",
  oz3: "So: Geschlossen",
};

export default function Kontakt() {
  const { user } = useAuth();
  const isAdmin = !!user?.isAdmin;

  const [info, setInfo] = useState(DEF);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(DEF);
  const [saveMsg, setSaveMsg] = useState(null);

  const [form, setForm]       = useState({ name: "", email: "", betreff: "", text: "" });
  const [success, setSuccess] = useState(false);
  const [error, setError]     = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.einstellungen.get(KEY).then(r => { if (r) setInfo(typeof r === "string" ? JSON.parse(r) : r); }).catch(() => {});
  }, []);

  async function saveInfo() {
    try {
      await api.einstellungen.update(KEY, JSON.stringify(draft));
      setInfo(draft);
      setEditing(false);
      setSaveMsg("✓ Gespeichert!");
      setTimeout(() => setSaveMsg(null), 3000);
    } catch { setSaveMsg("Fehler beim Speichern."); }
  }

  const set = k => e => setDraft(d => ({ ...d, [k]: e.target.value }));
  const c = editing ? draft : info;

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      await api.nachrichten.create(form);
      setSuccess(true);
      setForm({ name: "", email: "", betreff: "", text: "" });
    } catch { setError("Nachricht konnte nicht gesendet werden. Bitte versuche es erneut."); }
    finally { setLoading(false); }
  };

  return (
    <div className="container" style={{ maxWidth: 900 }}>
      <h2 className="section-title" style={{ marginTop: "1rem" }}>Kontakt</h2>
      {saveMsg && <p style={{ color: saveMsg.startsWith("✓") ? "green" : "red", margin: "0.5rem 0" }}>{saveMsg}</p>}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem", marginTop: "1.5rem" }}>

        {/* ── Kontaktinfos ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div className="card" style={{ border: "1.5px solid #a5d6a7" }}>
            <h3 style={{ marginBottom: "1rem" }}>📍 So finden Sie uns</h3>
            {editing ? (
              <>
                <input value={draft.adr1} onChange={set("adr1")} style={IN} />
                <input value={draft.adr2} onChange={set("adr2")} style={IN} />
                <input value={draft.adr3} onChange={set("adr3")} style={IN} />
              </>
            ) : (
              <>
                <p>{c.adr1}</p>
                <p>{c.adr2}</p>
                <p>{c.adr3}</p>
              </>
            )}
          </div>

          <div className="card" style={{ border: "1.5px solid #a5d6a7" }}>
            <h3 style={{ marginBottom: "1rem" }}>📞 Erreichbarkeit</h3>
            <p>
              <a href={KONTAKT.telefonHref} style={{ color: "#2e7d32", fontWeight: 600, textDecoration: "none", fontSize: "1.1rem" }}>
                {KONTAKT.telefon}
              </a>
            </p>
            <p style={{ marginTop: "0.5rem" }}>
              <a href="mailto:kontakt(at)milchbauernhof.de" style={{ color: "#2e7d32", textDecoration: "none" }}>
                kontakt(at)milchbauernhof.de
              </a>
            </p>
            <hr style={{ margin: "1rem 0", borderColor: "#e0e0e0" }} />
            <p style={{ fontWeight: 600, marginBottom: "0.4rem" }}>🕐 Öffnungszeiten</p>
            {editing ? (
              <>
                <input value={draft.oz1} onChange={set("oz1")} style={IN} />
                <input value={draft.oz2} onChange={set("oz2")} style={IN} />
                <input value={draft.oz3} onChange={set("oz3")} style={{ ...IN, color: "#c62828" }} />
              </>
            ) : (
              <>
                <p>{c.oz1}</p>
                <p>{c.oz2}</p>
                <p style={{ color: "#c62828" }}>{c.oz3}</p>
              </>
            )}
          </div>

          {isAdmin && !editing && (
            <button className="btn btn-secondary" onClick={() => { setDraft(info); setEditing(true); setSaveMsg(null); }}>
              ✏️ Infos bearbeiten
            </button>
          )}
          {editing && (
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <button className="btn btn-primary" onClick={saveInfo}>Speichern</button>
              <button className="btn btn-secondary" onClick={() => setEditing(false)}>Abbrechen</button>
            </div>
          )}
        </div>

        {/* ── Formular ── */}
        <div className="card">
          <h3 style={{ marginBottom: "1rem" }}>✉️ Nachricht schreiben</h3>
          {success && <div className="alert alert-success">✓ Nachricht erfolgreich gesendet!</div>}
          {error   && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Name *</label>
              <input name="name" value={form.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>E-Mail *</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Betreff</label>
              <input name="betreff" value={form.betreff} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Nachricht *</label>
              <textarea name="text" rows={4} value={form.text} onChange={handleChange} required />
            </div>
            <button className="btn btn-success" type="submit"
              disabled={loading || !form.name || !form.email || !form.text}
              style={{ width: "100%", opacity: (!form.name || !form.email || !form.text) ? 0.5 : 1 }}>
              {loading ? "Wird gesendet..." : "📨 Nachricht senden"}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}

const IN = { width: "100%", padding: "0.4rem", borderRadius: 5, border: "1px solid #ccc", fontSize: "0.95rem", marginBottom: "0.4rem", fontFamily: "inherit" };
